import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PrebuiltPC } from "@/types/types";
import { CreditCard } from "lucide-react";

interface PaymentTabsProps {
  product?: PrebuiltPC;
  paymentMethod: "stripe" | "paypal" | "zelle";
  onPaymentMethodChange: (value: "stripe" | "paypal" | "zelle") => void;
}

const PaymentTabs = ({ paymentMethod, onPaymentMethodChange }: PaymentTabsProps) => {
  return (
    <Tabs
      value={paymentMethod}
      onValueChange={(v) => onPaymentMethodChange(v as "stripe" | "paypal" | "zelle")}
      className="w-full"
    >
      <TabsList className="grid grid-cols-3 mb-4 bg-gaming-dark w-full">
        <TabsTrigger value="stripe" className="flex items-center gap-1 justify-center relative">
          <CreditCard size={16} />
          <span>Credit Card</span>
          <span className="ml-1 text-[10px] text-red-500 bg-red-100 rounded px-1 py-0.5 leading-none">
            +3%
          </span>
        </TabsTrigger>

        {/* TEMPORARILY DISABLED PAYPAL OPTION
        <TabsTrigger value="paypal" className="flex items-center justify-center relative">
          <span>PayPal</span>
          <span className="ml-1 text-[10px] text-red-500 bg-red-100 rounded px-1 py-0.5 leading-none">
            +3%
          </span>
        </TabsTrigger>
        */}

        <TabsTrigger value="zelle" className="flex items-center justify-center">
          <span>Zelle</span>
        </TabsTrigger>
      </TabsList>

      {/* Conditional Buy Now, Pay Later Info */}
      {/*
      (paymentMethod === "stripe" || paymentMethod === "paypal") && (
        <p className="text-xs text-foreground text-center mb-1">
          You can pay with Buy Now, Pay Later services using {paymentMethod === "stripe" ? "Credit Card (Stripe)" : "PayPal"}.
        </p>
      )
      */}
      {paymentMethod === "stripe" && (
        <p className="text-xs text-foreground text-center mb-1">
          You can pay with Buy Now, Pay Later services using Credit Card (Stripe).
        </p>
      )}

      <p className="text-xs text-muted-foreground text-center mt-1">
        No processing fee with Zelle.
      </p>
    </Tabs>
  );
};

export default PaymentTabs;
